module.exports = __webpack_public_path__ + "static/media/logo-white.d4670670.png";